import { IComponentOptions, IController } from 'angular';
import { GmcSelectController2 } from '../gmc-select2.component';
import './gmc-select-option.component.scss';

export class GmcSelectOptionController implements IController {
  value: any;
  isSelected = false;
  isVisible = true;
  private gmcSelect: GmcSelectController2;

  constructor() {
  }

  $onInit() {
    this.gmcSelect.addOption(this);
  }

  $onDestroy() {
    this.gmcSelect.removeOption(this);
  }

  onClick( event ) {
    event.preventDefault();
    if ( this.value ) {
      this.gmcSelect.selectOption(this);
    }
  }
}

export const GmcSelectOptionComponent: IComponentOptions = {
  controller: GmcSelectOptionController,
  require: {
    gmcSelect: '^gmcSelect2'
  },
  transclude: true,
  template: require('./gmc-select-option.component.html'),
  bindings: {
    value: '<'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-select-2/components/gmc-select-option.component.ts